import ModelEntity from "../../model-entity"
import {EntityType} from "../../../gd/const/item"
import {RequestFormType} from "../../../../app/tools/request-forms2/const/const"
import {ViewType} from "../../../gd/const/views/view-type"
import {ProjectPropertiesData} from "../types";
import ProjectSession from "../project-session";

type MenuSections = {
    info            : boolean
    users           : boolean
    customers       : boolean
    reports         : boolean
    integrations    : boolean
    automations     : boolean
    history         : boolean
    settings        : boolean
}

type SettingsSections = {
    workItems           : boolean
    taskTypes           : boolean
    customFields        : boolean
    views               : boolean
    workflow            : boolean
    taskId              : boolean
    navigation          : boolean

    tasksWorkflowBlock  : boolean
}

export type ProjectAvailableMenuOptions = {
    pinStar         : boolean,
    info            : boolean,
    users           : boolean,
    settings        : boolean,
    history         : boolean,
    rename          : boolean,
    editSource      : boolean, // link or embed
    colorIcon       : boolean,
    move            : boolean,
    convert         : boolean,
    duplicate       : boolean,
    saveAsTemplate  : boolean,
    delete          : boolean,

    status          : boolean,
    archive         : boolean   // instead of status ?
}

type PropertiesForm = {
    id          : string,
    name        : string,
    type        : RequestFormType,
    publicKey   : string,
}

export default class ProjectProperties extends ModelEntity {

    protected project               : ProjectSession

    public treatAsCatalog           : boolean
    public expenses                 : boolean
    public forms                    : PropertiesForm[]
    public url                      : string    // for QuickAddItemType.LINK

    // Allowed work items
    public canCreateTask            : boolean = false
    public canCreateProject         : boolean = false
    // public canCreatePage            : boolean = false
    public canCreateMeeting         : boolean = false
    public canCreateLink            : boolean = false
    public canCreateEmbed           : boolean = false
    public canCreateEvent           : boolean = false
    public canCreateDiscussion      : boolean = false
    public canCreateDocument        : boolean = false
    public canCreateGoal            : boolean = false
    public canCreateDashboard       : boolean = false
    public canCreateRequestForms    : boolean = false
    public canCreateAttachments     : boolean = false
    public canArchive               : boolean = false
    public canHaveStatus            : boolean = true   // if true this item may have status ... if not - archive only in future folder should be able to have tatuses !!!!
    public canHaveViews             : boolean = true

    public menuSections             : MenuSections
    public settingsSections         : SettingsSections
    public viewType?                : ViewType

    constructor(propertiesConfig:ProjectPropertiesData, project:ProjectSession) {
        super('', EntityType.DYNAMIC_MODEL)

        this.project                = project


        this.treatAsCatalog         = _.get(propertiesConfig,'treatAsCatalog', false)
        this.expenses               = _.get(propertiesConfig,'expenses', false)
        this.forms                  = _.get(propertiesConfig,'forms', [])
        this.url                    = _.get(propertiesConfig,'url', '')
        this.viewType               = _.get(propertiesConfig,'customViewType', undefined)

        this.menuSections           = {
            info            : true,
            users           : true,
            customers       : true,
            reports         : true,
            integrations    : true,
            automations     : true,
            history         : true,
            settings        : true
        }

        this.settingsSections       = {
            workItems           : true,
            taskTypes           : true,
            customFields        : true,
            views               : true,
            workflow            : true,
            taskId              : true,
            navigation          : true,

            tasksWorkflowBlock  : true, // block in workflow section
        }

    }

    get canCreate() {
        return _.find([
            this.canCreateTask,
            this.canCreateProject,
            // this.canCreatePage,
            this.canCreateMeeting,
            this.canCreateLink,
            this.canCreateEmbed,
            this.canCreateEvent,
            this.canCreateDiscussion,
            this.canCreateDocument,
            this.canCreateGoal,
            this.canCreateDashboard,
        ], value=>value)
    }

    get onClick(): func | null {
        return null
    }

    get handleExpandInsteadOfOpen():boolean {
        return this.treatAsCatalog
    }

    // More (Right click) menu option
    get availableMenuOptions(): ProjectAvailableMenuOptions {
        return {
            pinStar         : true,
            info            : true,
            users           : true,
            settings        : true,
            history         : true,
            rename          : true,
            editSource      : false,
            colorIcon       : true,
            move            : true,
            convert         : true,
            duplicate       : true,
            saveAsTemplate  : true,

            status          : true,
            archive         : false,

            delete          : true,
        }
    }

    static normalize(data:JSONObject) {
        return {
            treatAsCatalog  : _.get(data, 'treatAsCatalog', false),
            expenses        : _.get(data, 'expenses', false),
            forms           : _.get(data, 'forms', []),
            url             : _.get(data, 'url', null),
            customViewType  : _.get(data, 'customViewType', null),
        }
    }

    get hasBulkAction() {
        return true
    }

    // to be used in future ?
    hasField(fieldId:string):boolean {
        return true
    }

    // used in table / gantt
    hasColumn(columnId:string):boolean {
        return true
    }

    toJSON() {
        let res: any = {}

        // omit default values
        if (this.treatAsCatalog)        res.treatAsCatalog = true
        if (this.expenses)              res.expenses = true
        if (this.forms)                 res.forms = this.forms
        if (this.url)                   res.url = this.url
        if (this.viewType)        res.customViewType = this.viewType

        return res
    }
}
